import React from "react";
import { useParams } from "react-router-dom";
import { useConsumerListSummary } from "../../hooks";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import {
  MailWarning,
  Package,
  PackageCheck,
  UserCheck,
  UserSearch,
} from "lucide-react";

const ConsumerDashboard = () => {
  const params = useParams();
  const { data: summary } = useConsumerListSummary(params.id);

  const statsData = [
    {
      title: "Total Consumers",
      count: summary?.totalConsumer || 0,
      icon: <UserCheck className="h-8 w-8 text-blue-500" />,
      trendSummary: "Total consumers in this cycle",
    },
    {
      title: "Fully Delivered",
      count: summary?.fullyDelivered || 0,
      icon: <PackageCheck className="h-8 w-8 text-green-500" />,
      trendSummary: "Received bills via all channels",
    },
    {
      title: "At Least One Delivered",
      count: summary?.atLeastOneDelivered || 0,
      icon: <Package className="h-8 w-8 text-orange-500" />,
      trendSummary: "Received bills via at least one channel",
    },
    {
      title: "Failed All",
      count: summary?.failedAll || 0,
      icon: <MailWarning className="h-8 w-8 text-red-500" />,
      trendSummary: "Bills failed across all channels",
    },
    {
      title: "Missing Contact",
      count: summary?.missingContact || 0,
      icon: <UserSearch className="h-8 w-8 text-red-500" />,
      trendSummary: "Missing valid contact information",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          icon={stat.icon}
          trendSummary={stat.trendSummary}
          trendDirection={stat.trendDirection}
        />
      ))}
    </div>
  );
};

export default ConsumerDashboard;
